// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"354":"project","530":"page","597":"projects","757":"not-found","841":"studio","946":"news","962":"home"}[chunkId] || chunkId) + "." + {"354":"f470eb61","530":"e08e7ae5","564":"9452cf7a","597":"d57a0e59","757":"1c848060","841":"8105da66","946":"065eb29c","962":"4bd0f2ef"}[chunkId] + ".js";
};